import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abs',
  standalone: false
})
export class AbsPipe implements PipeTransform {
  transform(value: string | number): number {
    return Math.abs(Number(value));
  }
}
